import { toRadian } from '../utils/string.utilts';
import { LayoutBase } from './LayoutBase';

export default class extends LayoutBase {
  private getImageEl() {
    return (this.dataItem as IImage).imgEl;
  }
  getSize(): { width: number; height: number } {
    const imgEl = this.getImageEl();
    // 添加缩放
    const { _scale = 1 } = this;
    return {
      width: (imgEl?.width ?? 0) * _scale,
      height: (imgEl?.height ?? 0) * _scale
    };
  }
  draw(): void {
    const { x, y, ctx, dataItem, _scale, _alpha } = this;
    const imgEl = this.getImageEl();
    if (!imgEl) return;
    const { rotation = 0, src } = dataItem as IImage;
    const { width, height } = imgEl;
    const pivotX = width / 2;
    const pivotY = height / 2;
    const centerPoint = { x: x + pivotX, y: y + pivotY };
    ctx.save();
    ctx.translate(centerPoint.x, centerPoint.y); //默认从00开始旋转，这里设置中心点，绘制到中心点位置
    if (this.rotatable) {
      ctx.rotate(toRadian(rotation)); //开始顺时针方向旋转角度，rotation为旋转角度。
    }
    ctx.translate(-centerPoint.x, -centerPoint.y); //画布平移回来

    // 缩放值
    const w = width * _scale;
    const h = height * _scale;

    // 透明度
    ctx.globalAlpha = _alpha;

    // 离屏画布
    const { canvas: _canvas } = this.getOffscreen({
      width: w,
      height: h,
      init: (canvas, ctx) => {
        this.drawRecolorImage(ctx, imgEl, {
          x: 0,
          y: 0,
          w,
          h
        });
      },
      dirtyParmas: {
        src
      }
    });

    // ctx.drawImage(_canvas, x, y);
    // 动画
    this.drawAniFrame(_canvas);
    ctx.restore();
    this.setRuntimeData({
      width: w,
      height: h,
      rotation: rotation
    });
  }
}
